import { useEffect, useState } from "react";
import { api, errorText } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { fmtTime, msLabel } from "./omUtils";

export function EditDialog({ row, onClose, onSave }) {
  const [vals, setVals] = useState({});
  useEffect(() => { setVals({ over: row?.over?.odds ?? "", under: row?.under?.odds ?? "" }); }, [row]);
  const sides = ["over", "under"].filter((s) => row?.[s]);
  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="om-dialog" data-testid="om-edit-dialog">
        <DialogTitle>Edit odds · {row?.player_name} {row && msLabel(row)} · {row?.bookmaker}</DialogTitle>
        <p className="om-dim">A corrected price counts as verified and is saved in the history and the audit log.</p>
        <div className="om-edit-grid">
          {sides.map((s) => (
            <label key={s} className="om-field">{s === "over" ? "Over odds" : "Under odds"}
              <input type="number" step="0.01" min="1.01" value={vals[s]} onChange={(e) => setVals({ ...vals, [s]: e.target.value })} data-testid={`om-edit-${s}`} />
            </label>
          ))}
        </div>
        <div className="om-dialog-actions">
          <button type="button" onClick={onClose} data-testid="om-edit-cancel">Cancel</button>
          <button type="button" className="primary" onClick={() => onSave(row, vals)} data-testid="om-edit-save">Save</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function VersionsDialog({ row, shotNo, onClose, onOpenShot }) {
  const [data, setData] = useState({});
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!row) return;
    setData({}); setErr("");
    Promise.all(["over", "under"].filter((s) => row[s]).map((s) => api.get(`/value/picks/${row[s].id}/versions`).then((r) => [s, r.data])))
      .then((all) => setData(Object.fromEntries(all))).catch((e) => setErr(errorText(e)));
  }, [row]);
  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="om-dialog wide" data-testid="om-versions-dialog">
        <DialogTitle>Price history · {row?.player_name} {row && msLabel(row)} · {row?.bookmaker}</DialogTitle>
        {err && <p className="om-error">{err}</p>}
        <div className="om-versions">
          {Object.entries(data).map(([side, v]) => (
            <section key={side}>
              <h4>{side.toUpperCase()}</h4>
              {v.versions.map((h, i) => (
                <div key={i} className={`om-ver ${i === 0 ? "cur" : ""}`}>
                  <b>{h.odds.toFixed(2)}</b><span>{fmtTime(h.at)}</span>
                  {h.screenshot_id ? <button type="button" className="om-src" onClick={() => onOpenShot(h.screenshot_id)}>#{shotNo[h.screenshot_id] ?? "?"}</button> : <em>{h.manual ? "manual edit" : "—"}</em>}
                  {i === 0 && <small>active</small>}
                </div>
              ))}
              {!v.versions.length && <p className="om-dim">Scanned before history was kept.</p>}
              {v.audit.map((a, i) => <p key={i} className="om-audit">{fmtTime(a.at)} · {a.by} · {a.action}{a.action === "edited" ? ` ${a.before} → ${a.after}` : ""}</p>)}
            </section>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
